module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./~/redux-api-middleware-fixed/~/core-js/library/modules/$.add-to-unscopables.js
// module id = p4dE
// module chunks = 23